export default __webpack_public_path__ + "static/media/VideoLib.777ca39b.jpg";